import React from "react"

export function Plus({
  fill = "white",
  h,
  w,
  className = "",
}: {
  fill?: string
  h?: number
  w?: number
  className?: string
}) {
  return (
    <svg width={w} height={h} className={className} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 34 33">
      <path
        fill={fill}
        d="M17 0c-2.0865 0-3.7778 1.64162-3.7778 3.66667v9.16663H3.77778C1.69128 12.8333 0 14.475 0 16.5c0 2.025 1.69128 3.6667 3.77778 3.6667h9.44442v9.1666C13.2222 31.3584 14.9135 33 17 33s3.7778-1.6416 3.7778-3.6667v-9.1666h9.4444C32.3087 20.1667 34 18.525 34 16.5c0-2.025-1.6913-3.6667-3.7778-3.6667h-9.4444V3.66667C20.7778 1.64162 19.0865 0 17 0Z"
      />
    </svg>
  )
}
